module.exports = {"data":{"site":{"siteMetadata":{"title":"Familien und Flucht aus der DDR • Bund für Bildung e. V."}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 116
// module chunks = 60335399758886 114276838955818